import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../firebase";
import { query, collection, getDocs, where, orderBy, limit, startAfter } from "firebase/firestore";
import Header from "../components/Header";
import Footer from "../components/Footer";

/* document.getElementById("appBody").addEventListener("scroll", myFunction);

function myFunction() {
  console.log("scrolling");
} */

/* document.body.style.overflow = "hidden";
document.getElementById("dashboard_screen").style.overflow = "scroll"; */


function Dashboard() {
  const [user, loading] = useAuthState(auth);
  //const [name, setName] = useState("");
  const [ratings, setRatings] = useState("");
  const [lastVisible, setLastVisible] = useState("");
  const [sortBy, setSortBy] = useState("chronological"); // 'chronological' or 'rating'
  const navigate = useNavigate();

  const itemsPerPage = 10;

  const handleScroll = (e,lastVisible) => {
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (bottom) {
      console.log("At the bottom!");
      fetchMoreRatings(lastVisible);
    }
    try {
  
    } catch (err) {
      //console.error(err);
      alert("An error occured while fetching more ratings");
    }
  }

  const handleOrderClick = async () => {
    if (sortBy === "chronological") {
      // Fetch from Firestore ordered by rating (descending) and year (descending)
      try {
        const response = query(
          collection(db, "ratings"),
          where("userid", "==", user?.uid),
          orderBy("userid"),
          orderBy("rating", "desc"),
          orderBy("year", "desc"),
          limit(itemsPerPage)
        );
        const data = await getDocs(response);
        const lastVisible = data.docs[data.docs.length-1];
        let ratingArr = [];
        for (var i=0; i < data.docs.length; i++) {
          ratingArr[i] = data.docs[i].data();
          ratingArr[i].id = data.docs[i].id;
        }
        setRatings(ratingArr);
        setLastVisible(lastVisible);
        setSortBy("rating");
      } catch (err) {
        alert("An error occured while fetching ratings by rating and year");
      }
    } else {
      // Fetch from Firestore ordered by updated_at (descending)
      fetchRatings();
      setSortBy("chronological");
    }
  };

  const fetchRatings = async () => {
    try {
      const response = query(collection(db, "ratings"), 
                              where("userid", "==", user?.uid),
                              orderBy("updated_at", "desc"), 
                              limit(itemsPerPage));
      const data = await (getDocs(response));

      const lastVisible = data.docs[data.docs.length-1];
      //console.log("last", lastVisible);
      //const data = await (getDocFromCache(response));
      const l = data.docs.length;
      if (l === 0) return navigate("/noratings")
      let ratingArr = [];
      for (var i=0; i < l; i++) {
      //console.log(data.docs[i].data());
      ratingArr[i] = data.docs[i].data();
      // adding collection id to record data
      ratingArr[i].id = data.docs[i].id;
      }
      setRatings(ratingArr);
      setLastVisible(lastVisible);

    } catch (err) {
      //console.error(err);
      alert("An error occured while fetching ratings");
    }
  };

  const fetchMoreRatings = async (lastVisible) => {
    const response = query(collection(db, "ratings"),
                            where("userid", "==", user?.uid),
                            orderBy("updated_at", "desc"),
                            startAfter(lastVisible),
                            limit(itemsPerPage));
    const data = await(getDocs(response));
    const lastVisibleMore = data.docs[data.docs.length-1];
    const l = data.docs.length;
    if (l > 0) {
      let ratingArr = [];
      for (var i=0; i < l; i++) {
      //console.log(data.docs[i].data());
      ratingArr[i] = data.docs[i].data();
      // adding collection id to record data
      ratingArr[i].id = data.docs[i].id;
      }
      setRatings(ratings.concat(ratingArr));
      setLastVisible(lastVisibleMore);
    }
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (loading) return;
    if (!user) return navigate("/");
    fetchRatings();
  }, [user, loading]);
  //console.log(ratings);
  
    return (
      <>
      {loading === false ? (
        <>
          <div id="dashboard_screen" className="d-flex align-items-center flex-column mb-0 px-3 main_screen dashboard_screen" style={{height: "calc(100vh - 100px)", overflowY: "scroll"}} onScroll={ (e) => handleScroll(e, lastVisible) }>
            <Header key="1"  user={user} />
      
            <ul className="px-0 mt-3 ratings_list">
              {/* ratings is an object, not an array, so we need to use Object.keys() before map() */}
              {Object.keys(ratings).map(item => (
                
                <li key={item} className="rating pb-2 mt-3">
                  <a href={`/rate/${ratings[item].tmdb_id}`}>
                    <h2 className="rating_title">{ratings[item].title}</h2>
                    <h3 className="rating_original_title">{(ratings[item].original_title !== ratings[item].title) ? ratings[item].original_title : ""}</h3>
                    <h4 className="rating_year">{ratings[item].year}</h4>
                    <div className="rating_rate">
                      <RatingRate rate={ratings[item].rating} key={item} />
                    </div>
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <Footer key="footer" user={user} onOrderClick={handleOrderClick} />
        </>
      ) : (
      <div className="loadingscreen">
        <div className="loading spinner-border text-warning"></div>
      </div>
      ) }
      </>
    );
  
}

const RatingRate = (rate) => {
  switch(rate.rate) {
    case 1: 
      return (<div className="dots"><span>o</span><span className="none">o</span><span className="none">o</span><span className="none">o</span><span className="none">o</span></div>);
    case 2: 
      return (<div className="dots"><span>o</span><span>o</span><span className="none">o</span><span className="none">o</span><span className="none">o</span></div>);
    case 3: 
      return (<div className="dots"><span>o</span><span>o</span><span>o</span><span className="none">o</span><span className="none">o</span></div>);
    case 4: 
      return (<div className="dots"><span>o</span><span>o</span><span>o</span><span>o</span><span className="none">o</span></div>);
    case 5: 
      return (<div className="dots"><span>o</span><span>o</span><span>o</span><span>o</span><span>o</span></div>);
    default:
      return (<div className="none"><span>o</span><span className="none">o</span><span className="none">o</span><span className="none">o</span><span className="none">o</span></div>);
  } 
} 

export default Dashboard;
